var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/logout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6272 10.2467C11.5006 10.2467 11.3739 10.2 11.2739 10.1C11.0806 9.90666 11.0806 9.58666 11.2739 9.39332L12.6272 8.03999L11.2739 6.68666C11.0806 6.49332 11.0806 6.17332 11.2739 5.97999C11.4672 5.78666 11.7872 5.78666 11.9806 5.97999L13.6872 7.68666C13.8806 7.87999 13.8806 8.19999 13.6872 8.39332L11.9806 10.1C11.8806 10.2 11.7539 10.2467 11.6272 10.2467Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.2859 8.54001H6.50586C6.23253 8.54001 6.00586 8.31334 6.00586 8.04001C6.00586 7.76668 6.23253 7.54001 6.50586 7.54001H13.2859C13.5592 7.54001 13.7859 7.76668 13.7859 8.04001C13.7859 8.31334 13.5592 8.54001 13.2859 8.54001Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.83919 13.8333C4.40586 13.8333 2.00586 11.4333 2.00586 7.99999C2.00586 4.56666 4.40586 2.16666 7.83919 2.16666C8.11253 2.16666 8.33919 2.39332 8.33919 2.66666C8.33919 2.93999 8.11253 3.16666 7.83919 3.16666C4.99253 3.16666 3.00586 5.15332 3.00586 7.99999C3.00586 10.8467 4.99253 12.8333 7.83919 12.8333C8.11253 12.8333 8.33919 13.06 8.33919 13.3333C8.33919 13.6067 8.11253 13.8333 7.83919 13.8333Z",
    fill: "#878787"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f12ca9c9c6a0323e3dc7d5b8ee2f5c1f.svg";
export { ForwardRef as ReactComponent };